// component used to increment and decrement the value in the fpl+fuel page
import React from "react"
import {Box, IconButton, InputAdornment, TextField} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const IncDecInput = ({value, onChange}) => {

  const handleChange = (e) => {
    onChange(e.target.value < 0 ? 0 : e.target.value)
  }

  return(
    <Box style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
      <IconButton onClick={() => onChange((+value - 0.1).toFixed(1))} disabled={value <= 0}>
        <RemoveIcon style={{color: value > 0? "var(--norwegian-red)": "grey"}}/>
      </IconButton>
      <TextField value={value} onChange={handleChange} style={{width: "80px"}}
                 type={"number"}
                 InputProps={{
                   endAdornment: <InputAdornment position="end"><p style={{color: "#000"}}>T</p></InputAdornment>,
                   style: {textAlign: "center"},
                 }}
      />
      <IconButton onClick={() => onChange((+value + 0.1).toFixed(1))}>
        <AddIcon style={{color: "var(--green)"}}/>
      </IconButton>
    </Box>
  )
}
export default IncDecInput